export const ICON_IMG = {
    brandSolid: 'https://s.qunarzz.com/q_design_font/images/checkBoxBrandSolid.png',
    brandEmpty: 'https://s.qunarzz.com/q_design_font/images/checkBoxBrandEmpty2.png',
    graySolid: 'https://s.qunarzz.com/q_design_font/images/checkBoxGraySolid.png',
    grayEmpty: 'https://s.qunarzz.com/q_design_font/images/checkBoxGrayEmpty2.png',
    selected: 'https://s.qunarzz.com/q_design_font/images/checkBoxSelected.png',
    unavailable: 'https://s.qunarzz.com/q_design_font/images/checkBoxUnavailable.png'
};
